module.exports = __webpack_public_path__ + "img/T6-C-xs_2.10a0ca67.png";